import {
    AudienceID,
    ChannelID,
    RealmID,
} from 'api/types/properties'
import {RouteParamsList} from 'navigation/types'

export enum RouteName {
    EmbedHome = 'EmbedHome',
    EmbedChannel = 'EmbedChannel',
    EmbedQueue = 'EmbedQueue',
    Queue = 'Queue',
    Channel = 'Channel',
    Realm = 'Realm',
    Else = 'Else',
    Transcript = 'Transcript',
    RegisteredAudience = 'RegisteredAudience',
}

export type ChannelRoute = {
    name: RouteName.EmbedChannel | RouteName.Channel
    params: {
        channel_id: ChannelID
    }
}

export type RealmRoute = {
    name: RouteName.Realm
    params: {
        realm_id: RealmID
    }
}

export type AudienceRoute = {
    audience_id: AudienceID
    name: RouteName.EmbedChannel | RouteName.Channel
    metadata?: Record<string, unknown>[]
    params: {
        channel_id: ChannelID
    }
}

export type ElseRoute = {
    name: RouteName.Else
}

export type QueueRoute = {
    name: RouteName.EmbedQueue | RouteName.Queue
    params: {
        queue_id: string
        metadata?: RouteParamsList['EmbedQueue']['metadata']
    }
}

export type TranscriptRoute = {
    audience_id: AudienceID
    name: RouteName.Transcript
    metadata?: Record<string, unknown>[]
    params: {
        audience_id: AudienceID
    }
}

export type RegisteredAudienceRoute = {
    audience_id: AudienceID
    name: RouteName.RegisteredAudience
    metadata?: Record<string, unknown>[]
    params: {
        audience_id: AudienceID
    }
}
